import useDialog from './use-dialog';
import { ConfirmationDialog } from '../dialogs/confirmation';

function useConfirmationDialog(props) {
  return useDialog(ConfirmationDialog, props);
}

export default useConfirmationDialog;